import React from 'react';
import FindTeammatePage from '../../../pages/FindTeammatePage';

export default function HelpFindTeammatePanel() {
  return <FindTeammatePage embedded />;
}
